import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Text } from '@components/Restyle';
import Button from '@components/shared/Button/Button';

interface AnnualBillingSectionProps {
  memberCount: number;
  onConfirm: () => void;
  buttonText?: string;
}

const ANNUAL_PRICE_PER_MEMBER = 16;

export const AnnualBillingSection: React.FC<AnnualBillingSectionProps> = ({
  memberCount,
  onConfirm,
  buttonText,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Box my='m'>
        <Text mb='xs' variant='labelSmall' color='textPrimary'>
          {t('models:teams.subscriptions.billingCycle', {
            defaultValue: 'Billing Cycle',
          })}
        </Text>
        <Box
          flexDirection='row'
          borderColor='greenSecondary'
          backgroundColor='white'
          borderWidth={2}
          borderRadius='s'
          padding='xs'>
          <Box flexDirection='column' flex={1}>
            <Text variant='webSmall' color='textSecondary' numberOfLines={1}>
              {t('models:teams.subscriptions.yearly', {
                defaultValue: 'Yearly',
              })}
            </Text>
            <Box flexDirection='row'>
              <Text
                marginTop='xs'
                variant='webBodySecondary'
                color='textSecondary'
                numberOfLines={1}>
                {`$${ANNUAL_PRICE_PER_MEMBER} /member/month`}
              </Text>
              <Box
                marginHorizontal='xs'
                marginTop='xxxs'
                style={{
                  backgroundColor: '#DCF2EC',
                  borderRadius: 4,
                  padding: 4,
                }}>
                <Text variant='metadata' color='greenSecondary'>
                  {t('models:teams.subscriptions.save20', {
                    defaultValue: 'Save 20%',
                  })}
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box flex={1} position='absolute' bottom={20} left={0} right={0}>
        <Box flexDirection='column'>
          <Box flex={1} flexDirection='row' mb='xs'>
            <Text variant='webBodySecondary' color='textSecondary'>
              {t('models:teams.subscriptions.youllBeCharged', {
                defaultValue: "You'll be charged ",
              })}
            </Text>
            <Text variant='webBodySecondary' color='textPrimary'>
              {(() => {
                const totalCost = memberCount * ANNUAL_PRICE_PER_MEMBER * 12;
                return `$${totalCost} per year.`;
              })()}
            </Text>
          </Box>
          <Text mb='l' variant='webBodySecondary' color='textSecondary'>
            {t('models:teams.subscriptions.applicableTaxes', {
              defaultValue:
                'Applicable taxes will be calculated on the checkout',
            })}
          </Text>
        </Box>
        <Button
          isSmall={true}
          height={48}
          fullWidth={true}
          borderWidth={0}
          btnTextColor='white'
          backgroundColor='greenSecondary'
          variant='primary'
          onPress={onConfirm}>
          {buttonText || t('shared:confirm', { defaultValue: 'Confirm' })}
        </Button>
      </Box>
    </>
  );
};
